import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "mx-auto max-w-7xl force-font" };
import { useMainStore } from '@/store/main';
import { PlusIcon } from '@gohighlevel/ghl-icons/24/outline';
import { UIDatepicker, UIEmpty, UIHeader, UITable } from '@gohighlevel/ghl-ui';
import '@gohighlevel/ghl-ui/dist/style.css';
import dayjs from 'dayjs';
import { debounce } from 'lodash';
import { inject, onBeforeUnmount, onMounted, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { PaymentServices } from '../../services/PaymentService';
import { FilterActionOptions, FilterCollapseOptions, getColumnsHeading, } from './table';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PaymentLinksDashboard',
    setup(__props) {
        const router = inject('router');
        const { t } = useI18n();
        const store = useMainStore();
        const eventBus = inject('emitter');
        const data = reactive({
            paymentLinks: [],
            loading: false,
        });
        const pagination = reactive({
            limit: 10,
            offset: 0,
            total: 0,
        });
        const filters = reactive({
            search: '',
            dateRange: undefined,
            active: 'all',
            sourceType: 'payments_dashboard',
        });
        const ColumnsHeading = getColumnsHeading(t, eventBus);
        const filterActionOptions = FilterActionOptions(t);
        const filterCollapseOptions = FilterCollapseOptions(t);
        function openPaymentLinkEditor() {
            return router.push({ name: 'payment-links-editor', params: { id: 'new' } });
        }
        const getPaymentLinks = async () => {
            try {
                data.loading = true;
                const response = await PaymentServices.listPaymentLinks({
                    altId: store.$state.altId,
                    altType: store.$state.altType,
                    limit: pagination.limit,
                    offset: pagination.offset,
                    active: filters.active,
                    startAt: filters.dateRange?.[0] &&
                        dayjs(filters.dateRange[0]).format('YYYY-MM-DD'),
                    endAt: filters.dateRange?.[1] &&
                        dayjs(filters.dateRange[1]).format('YYYY-MM-DD'),
                    search: filters.search,
                    sourceType: filters.sourceType,
                });
                const { paymentLinks, total } = response.data;
                data.paymentLinks = paymentLinks;
                pagination.total = total;
                data.loading = false;
            }
            catch (error) {
                data.loading = false;
                console.error(error);
            }
        };
        const debouncedGetPaymentLinks = debounce(getPaymentLinks, 500);
        onMounted(() => {
            getPaymentLinks();
            eventBus.on('redirect-editor', (data) => {
                router.push({ name: 'payment-links-editor', params: { id: data?._id } });
            });
            eventBus.on('toggle-link-status', (item) => {
                togglePaymentLinkStatus(item?._id, item.active);
            });
        });
        async function togglePaymentLinkStatus(paymentLinkId, currentStatus) {
            const updatedPaymentLink = await PaymentServices.updatePaymentLinkStatus(paymentLinkId, {
                activeValue: !currentStatus,
            });
            if (updatedPaymentLink) {
                console.info('PaymentLink Status updated sucessfully');
                getPaymentLinks();
            }
        }
        onBeforeUnmount(() => {
            eventBus.off('redirect-editor');
        });
        function onPageSizeUpdate(size) {
            pagination.limit = size;
            getPaymentLinks();
        }
        function pageChange(page) {
            pagination.offset = (page - 1) * pagination.limit;
            getPaymentLinks();
        }
        function onUpdateFilter({ filters: newFilters }) {
            if (newFilters && newFilters?.length) {
                newFilters.forEach((filter) => {
                    filters[filter.key] = filter.value;
                });
            }
            else {
                filters.value.sourceType = 'payments_dashboard';
                filters.value.active = 'all';
            }
            pagination.offset = 0;
            getPaymentLinks();
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(UIHeader), {
                    id: "payment-links-header",
                    title: _ctx.$t('dashboard.title'),
                    description: _ctx.$t('dashboard.description'),
                    primaryText: _ctx.$t('dashboard.createBtnLabel'),
                    onPrimaryClick: openPaymentLinkEditor,
                    primaryActionIcon: _unref(PlusIcon)
                }, null, 8, ["title", "description", "primaryText", "primaryActionIcon"]),
                _createVNode(_unref(UITable), {
                    id: "paymentLinks",
                    loading: data.loading,
                    columns: _unref(ColumnsHeading),
                    data: data.paymentLinks,
                    page: pagination.offset / pagination.limit + 1,
                    pageSize: pagination.limit,
                    pageCount: Math.ceil(pagination.total / pagination.limit),
                    showSizePicker: true,
                    searchText: filters.search,
                    "onUpdate:searchText": [
                        _cache[1] || (_cache[1] = ($event) => ((filters.search) = $event)),
                        _unref(debouncedGetPaymentLinks)
                    ],
                    "onUpdate:pageSize": onPageSizeUpdate,
                    "onUpdate:page": pageChange,
                    searchInputPlaceholder: _ctx.$t('common.search'),
                    filterCollapseItems: _unref(filterCollapseOptions),
                    filterOptions: _unref(filterActionOptions),
                    "onUpdate:filter": onUpdateFilter
                }, {
                    empty: _withCtx(() => [
                        _createVNode(_unref(UIEmpty), {
                            id: "payment_links_products__empty",
                            title: _ctx.$t('dashboard.title'),
                            positiveText: 'Create Link',
                            onPositiveClick: openPaymentLinkEditor,
                            positiveIcon: _unref(PlusIcon),
                            class: "mr-0"
                        }, null, 8, ["title", "positiveIcon"])
                    ]),
                    "filter-left": _withCtx(() => [
                        _createVNode(_unref(UIDatepicker), {
                            id: "payment-links-date-range",
                            type: "daterange",
                            clearable: "",
                            format: "MMMM d, yyyy",
                            "input-readonly": "",
                            value: filters.dateRange,
                            "onUpdate:value": [
                                _cache[0] || (_cache[0] = ($event) => ((filters.dateRange) = $event)),
                                _unref(debouncedGetPaymentLinks)
                            ]
                        }, null, 8, ["value", "onUpdate:value"])
                    ]),
                    _: 1
                }, 8, ["loading", "columns", "data", "page", "pageSize", "pageCount", "searchText", "onUpdate:searchText", "searchInputPlaceholder", "filterCollapseItems", "filterOptions"])
            ]));
        };
    }
});
